import { render, staticRenderFns } from "./DomBeard.vue?vue&type=template&id=985ac072&"
import script from "./DomBeard.vue?vue&type=script&lang=js&"
export * from "./DomBeard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports